<h2 mat-dialog-title style="margin-bottom: 20px;">{{title}}</h2>
<mat-dialog-content>
  <div [innerHTML]="message"></div>
  <div style="margin-top: 10px; margin-bottom: 10px;" *ngIf="showAcknowledge">
    <mat-checkbox [(ngModel)]="acknowledged">Acknowledge</mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button id="ok-dialog-button" mat-raised-button color="primary" [disabled]="showAcknowledge && !acknowledged" (click)="ok()">OK</button>
  <button id="cancel-dialog-button" mat-raised-button color="secondary" (click)="cancel()" *ngIf="!hideCancel">Cancel</button>
</mat-dialog-actions>
